"use client";
import { useGetProfileQuery } from "@/api/AppApi/services/auth";
import HoverDropDown from "../../header-common/menu/pc/HoverDropDown";
import UserMenuContent from "../../header-common/UserMenuContent";
import MenuLink from "../../header-common/menu/MenuLink";
import SvgLanguage from "../../header-common/common-header-icons/SvgLanguage";
import LanguageSwitch from "../../../toggle-switch/LanguageSwitch";
import Logout from "../../header-common/Logout";
import PCUserAvatar from "./PCUserAvatar";
import { useTranslation } from "@/hooks/localization/useTranslations";
interface Props {}

const UserMenu: React.FC<Props> = () => {
  const t = useTranslation();
  const getUser = useGetProfileQuery();
  const user = getUser.data?.result;

  return (
    <div className="user-menu">
      <HoverDropDown
        down
        title={<PCUserAvatar avatar={user?.avatar ?? ""} />}
        reversed
      >
        <UserMenuContent />
        <hr />
        <MenuLink
          onClick={() => {}}
          title={{
            Svg: <SvgLanguage />,
            text: t.language,
            other: <LanguageSwitch mobile />,
          }}
        />
        <hr />
        <Logout />
      </HoverDropDown>
    </div>
  );
};

export default UserMenu;
